module.exports = __webpack_public_path__ + "static/media/price-pollen.b385f23a.webp";